import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { VerticalMenuIcon } from 'foundations-assets/icons/components/VerticalMenuIcon';
import { DeleteMilestoneModal } from './DeleteMilestoneModal';
import { ButtonHoverContainer } from './styledComponents/ButtonHoverContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MenuIconButton = props => /*#__PURE__*/_jsx(ButtonHoverContainer, {
  children: /*#__PURE__*/_jsx(IconButton, Object.assign({}, props, {
    use: "transparent",
    size: "extra-small",
    children: /*#__PURE__*/_jsx(VerticalMenuIcon, {
      color: "text-core-default"
    })
  }))
});
export const MilestoneMenu = ({
  milestone,
  onDelete
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Dropdown, {
      Button: MenuIconButton,
      dropdownStyles: {
        paddingBlock: '50'
      },
      children: /*#__PURE__*/_jsx(ButtonHoverContainer, {
        children: /*#__PURE__*/_jsx(Button, {
          use: "transparent",
          size: "extra-small",
          block: true,
          onClick: () => setShowDeleteModal(true),
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(DeleteIcon, {
              color: "icon-alert-default",
              size: "200"
            }), /*#__PURE__*/_jsx(Text, {
              color: "icon-alert-default",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "dealPlan.milestones.delete"
              })
            })]
          })
        })
      })
    }), showDeleteModal && /*#__PURE__*/_jsx(DeleteMilestoneModal, {
      title: milestone.title,
      onClose: () => setShowDeleteModal(false),
      onDelete: () => {
        setShowDeleteModal(false);
        onDelete();
      }
    })]
  });
};